<script setup lang="ts">
// Pausa Temporária (Jogo Responsável) do Minha Conta V2 (ENG-362).
// Só existe com o flag ligado; sem flag manda pro fluxo antigo de proteção.
const { isUserV2Enabled } = useFeatureFlagsJson();

useSeo({
  title: 'Pausa Temporária',
});

if (!isUserV2Enabled.value) {
  await navigateTo(localeLink('/user/account-protection'), {
    redirectCode: 302,
  });
}
</script>

<template>
  <UserV2ScreenTemporaryPause v-if="isUserV2Enabled" />
</template>
